export const APP_CONFIG = {
  NAME: 'HR Portal',
  VERSION: '1.0.0',
  BASE_URL: import.meta.env.REACT_APP_BASE_URL || 'https://apidev.hrtalky.com',
  API_BASE_URL: import.meta.env.REACT_APP_API_BASE_URL || 'https://apidev.hrtalky.com/api',
  // For local connect
  // BASE_URL: import.meta.env.REACT_APP_BASE_URL || 'http://localhost:5000',
  // API_BASE_URL: import.meta.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api',
  // BASE_URL: import.meta.env.REACT_APP_BASE_URL || 'https://apidev.hrtalky.com',
  // API_BASE_URL: import.meta.env.REACT_APP_API_BASE_URL || 'https://apidev.hrtalky.com/api',
  TOKEN_KEY: 'idToken',
  THEME_KEY: 'theme-mode',
} as const;

export const USER_ROLES = {
  SUPER_ADMIN: 'Super Admin',
  ADMINISTRATOR: 'Administrator',
  STAFF: 'Staff',
  STUDENT: 'Student',
  PARENTS: 'Parents',
  USER: 'User',
} as const;
// Membership Tiers
export const MEMBERSHIP_TIERS = {
  FREE: 'free',
  PREMIUM: 'premium'
} as const;

export const COMPONENT_SIZE_LIMIT = 500;
